export enum GENDER {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    DIVERS = 'DIVERS',
}

export enum SERVICECONTACTTABS {
    PHONE = 'PHONE',
    EMAIL = 'EMAIL',
}

export const distributionTabs = ['probefahrt', 'allg-anfrage', 'reservierung'] as const;
export type DISTRIBUTIONTABS = (typeof distributionTabs)[number];

export interface M020C030InputSelectOption {
    label: string;
    value: string | number;
}
